import React from "react";
import { Redirect, Route } from "react-router-dom";

import Api from "../../helpers/apiHelpers";
import {useLocation} from "react-router";

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};
const PrivateRoute = ({children, ...rest}) => {
  const query = useQuery();

  //Add in logic for redirects of /gifts and /benefits
  return (
      Api.isLoggedIn?
          <Route {...rest}>
            {children}
          </Route>

          :
          <Redirect to="/login" />
  );
};

export default PrivateRoute;
